import { render, staticRenderFns } from "./SelectStudentDialog.vue?vue&type=template&id=bd0474d8&"
import script from "./SelectStudentDialog.vue?vue&type=script&lang=js&"
export * from "./SelectStudentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports